/* eslint-disable import/extensions */
<template>
  <md-tabs md-sync-route class="md-transparent">
    <md-tab
      v-for="route of routes"
      :key="route.path"
      :to="handleToRoute(route)"
      :id="'tab-' + route.path"
      :md-label="route.name"
    >
    </md-tab>
  </md-tabs>
</template>

<script>
import { settingsRoutes, customersProfileRoutes } from '../config/index';
import { checkAccess } from '../utils/Acl.util';

export default {
  name: 'TabRouter',
  props: ['isCustomersRoute'],

  data() {
    return {
      hasPermission: [],
      routes: [{ name: 'Profile', path: 'profile' }],
    };
  },
  methods: {
    checkAccess,
    fetchRoutes() {
      let componentRoute = [];

      if (this.isCustomersRoute) {
        componentRoute = customersProfileRoutes;
      } else {
        componentRoute = settingsRoutes;
      }

      const routes = componentRoute.filter((r) => {
        if (r.meta.requireAuth) {
          // const hasAccess = r.resources
          //   .map((resource) => this.$store.state.acl.hasOwnProperty(resource))
          //   .reduce((a, c) => a && c);

          const hasAccess = this.checkAccess(r.meta.resources);

          if (hasAccess) {
            // this.hasPermission.push(r.resources[0]);
            // this.hasPermission = [...this.hasPermission, r.resources[0]];
            this.updatePermisiion(r.meta.resources[0]);
          }

          return hasAccess;
        }

        return true;
      });

      this.routes = routes;
    },
    updatePermisiion(resource) {
      this.hasPermission = [...this.hasPermission, resource];
    },
    handleToRoute(route) {
      if (this.isCustomersRoute) {
        return `/customers/${route.path}?queryId=${this.$route.query.queryId}`;
      }
      return `/settings/${route.path}`;
    },
  },
  created() {
    this.fetchRoutes();
  },
};
</script>

<style scoped></style>
